import React from 'react';
import ContentLoaderBase from 'react-content-loader';

// react-content-loader ships no type definitions; treat as untyped, matching
// the FileSaver/react-select pattern used elsewhere in this migration.
const ContentLoader: any = ContentLoaderBase;

interface LBContentLoaderProps {
    style?: React.CSSProperties;
    basic?: boolean;
    [key: string]: any;
}

const LBContentLoader = (props: LBContentLoaderProps) => {
    var {style, basic, ...otherProps} = props;
    var primaryColor = '#e1e1e1';
    var secondaryColor = '#cbcbcb';
    if(basic){
        return <ContentLoader width="100" height="100" {...otherProps} style={style} preserveAspectRatio='none' primaryColor={primaryColor} secondaryColor={secondaryColor}>
        <rect x="0" y="0" rx="0" ry="0" width="100" height="100" preserveAspectRatio='none' />
        </ContentLoader>
    }
    var baseStyle: React.CSSProperties = {
        borderRadius: '4px'
    };
    style = Object.assign(baseStyle, style)
    return <ContentLoader {...otherProps} style={style} preserveAspectRatio='none' primaryColor={primaryColor} secondaryColor={secondaryColor}/>
};

export default LBContentLoader;
